module.exports = __webpack_public_path__ + "06_hige_gray.dbdff4b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/06_hige_gray.png
// module id = 6Pga
// module chunks = 0